<template>
  <v-card class="ma-3">
    <v-card-title primary-title>
      <div class="headline">{{ selectedFeature }}</div>
    </v-card-title>
    <v-card-text>
      <v-layout row justify-center>
        <v-flex xs8>
          <v-expansion-panel>
            <v-expansion-panel-content
              v-for="(question, index) in questions"
              :key="index"
            >
              <div slot="header">{{ question.title }}</div>
              <v-card>
                <v-card-text class="grey lighten-3">{{ question.answer }}</v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn primary flat>comenzar tutorial</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'geofences-faq',
  props: {
    selectedFeature: String
  },
  data: function () {
    return {
      questions: [
        {
          title: '¿Qué es el Acimut?',
          answer: 'Es la orientación del vehículo'
        }
      ]
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/FAQ/EventTemplate.vue